<template>
  <div>
    <v-autocomplete
      :value="selected"
      @input="$emit('input', $event)"
      :items="items"
      :multiple="multiple"
      :label="label"
      :item-text="itemText"
      :item-value="itemValue"
      :search-input.sync="search"
      no-data-text="Ничего не найдено"
      :loading="loading"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DynamicSelector',
  props: {
    value: {
      type: [Array, String, Number],
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    itemText: {
      type: String,
      default: 'label',
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      required: true,
    },
    method: {
      type: String,
      default: 'get',
    },
  },

  data() {
    return {
      items: [],
      // payload: {},
      loading: false,
      search: null,
    };
  },

  computed: {
    selected: {
      get() {
        return this.value
      },
      set(item) {
        this.$emit('input', item)
      },
    },
  },

  methods: {
    ...mapActions({
      loadDynamicData: 'dynamic_reports/loadDynamicData',
    }),

    loadItems() {
      this.loading = true;

      this.loadDynamicData({ url: this.url, method: this.method, data: this.data })
        .then(resp => {
          this.items = resp.data;
        }).catch(error => {
          console.error(error);
        }).finally(() => {
          this.loading = false;
        });
    }
  },

  mounted() {
    this.loadItems();
  },
}
</script>